import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=2320d4cd&scoped=true&"
import script from "./TheHeader.vue?vue&type=script&lang=js&"
export * from "./TheHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=2320d4cd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320d4cd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IArrowLeft: require('/opt/build/repo/components/svg/ArrowLeft.vue').default,ICommercantsLocaux: require('/opt/build/repo/components/svg/CommercantsLocaux.vue').default,ILogoWord: require('/opt/build/repo/components/svg/LogoWord.vue').default,ILogoWordFlat: require('/opt/build/repo/components/svg/LogoWordFlat.vue').default,TheHeaderMenu: require('/opt/build/repo/components/TheHeaderMenu.vue').default,AirtableImage: require('/opt/build/repo/components/AirtableImage.vue').default,HeaderCartButton: require('/opt/build/repo/components/HeaderCartButton.vue').default,IMenu: require('/opt/build/repo/components/svg/Menu.vue').default,TheHeaderMobileMenu: require('/opt/build/repo/components/TheHeaderMobileMenu.vue').default})
